import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

export default function Pricing() {
  return (
    <div className=" p-20  flex flex-col items-center">
      <div className="text-center">
        <h2 className="text-4xl mt-2 font-bold">
          Stay ahead in your career with practical solutions
        </h2>
        <h3 className="text-2xl text-teal-800 mt-4">
          Choose the price that you can really afford
        </h3>
      </div>
      <div className="rounded-xl flex justify-center space-x-8 mt-12">
        <div className="bg-gray-200 p-6 border rounded-lg text-center">
          <h1 className="text-xl font-bold">One-time Subscription</h1>
          <ul className="list-disc list-inside mt-4">
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              Single session
            </li>
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              No time limit
            </li>
            <li className="flex items-center mb-2">
              <FaTimes className="text-red-500 mr-2" />
              No Recorded session
            </li>
            <li className="flex items-center mb-2">
              <FaTimes className="text-red-500 mr-2" />
              No Doubt sessions
            </li>
            <li className="flex items-center mb-2">
              <FaTimes className="text-red-500 mr-2" />
              Feedback/Reports
            </li>
          </ul>
          <h2 className="text-2xl font-bold mt-4 text-left bg-black text-white px-5 py-3 rounded-lg">
            Rs 29/ Session
          </h2>
        </div>
        <div className="bg-yellow-100 p-6 border rounded-lg text-center">
          <h1 className="text-xl font-bold">Monthly Subscription</h1>
          <ul className="list-disc list-inside mt-4">
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              10 Sessions
            </li>
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              No time limit
            </li>
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              Recorded session
            </li>
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              Doubt sessions
            </li>
            <li className="flex items-center mb-2">
              <FaCheck className="text-green-500 mr-2" />
              Feedback/Reports
            </li>
          </ul>
          <h2 className="text-2xl font-bold mt-4 text-center  bg-black text-white px-5 py-3 rounded-lg">
            Rs 299
          </h2>
        </div>
      </div>
    </div>
  );
}
